var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page1warp"},[_c('div',{staticClass:"ruleModule_warp"},[_c('div',{staticClass:"ruleDetail_box",domProps:{"innerHTML":_vm._s(_vm.contentObj.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }